import { FC } from 'react'

const App: FC = () => <div style={{ flex: 1, display: 'flex' }}>Hello, React:)</div>

export default App
